export default {
	state: {
		active: false,
		complete: false,
		currentTooltipIndex: 0,
		activeTooltip: false,
	},
	actions: {
		skipTutorial(context) {
			context.commit("deactivateTooltip");
			context.commit("skipTutorialIndexes");
			context.commit("completeTutorial");
		},
	},
	mutations: {
		incrementTooltipIndex(state) {
			state.currentTooltipIndex += 1;
		},
		skipTutorialIndexes(state) {
			state.currentTooltipIndex = state.currentTooltipIndex.length - 1;
		},
		activateTooltip(state) {
			state.activeTooltip = true;
		},
		deactivateTooltip(state) {
			state.activeTooltip = false;
		},
		completeTutorial(state) {
			state.complete = true;
		},
		activateTutorial(state) {
			state.active = true;
		},
		deactivateTutorial(state) {
			state.active = false;
		},
	},
	getters: {
		currentTooltip(state, getters, rootState, rootGetters) {
			let tooltip = false;

			if (rootGetters.configLoaded
				&& state.currentTooltipIndex < rootState.config.tutorial.messages.length) {
				tooltip = rootState.config.tutorial.messages[state.currentTooltipIndex];
			}

			return tooltip;
		},
		nextTooltipExists(state, getters, rootState, rootGetters) {
			return rootGetters.configLoaded &&
				state.currentTooltipIndex + 1 <= rootState.config.tutorial.messages.length;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/tutorial.js